<template>
  <div class="body">
    <el-row style="margin-top: 20px">
      <el-col>
        <el-descriptions title="交付资源"> </el-descriptions>
        <select-file  :size="50" :value="selectedFileIds" button-text="新增交付" value-type="id"  @change="commitDelivery"></select-file>
        <el-table
          size="mini"
          stripe
          border
          highlight-current-row
          style="margin-top: 20px"
          :data="sourceList"
          row-key="id"
          @expand-change="expandContent"
          :expand-row-keys="expandRows"
        >
          <el-table-column type="expand">
            <template slot-scope="scope">
              <div style="padding: 20px;">
                <select-file  :size="50" :value="selectedFileIds" button-text="添加内容" value-type="id"  @change="(fileIds)=>{
                addContent(scope.row.id,fileIds)
              }"></select-file>
                <el-table
                    size="mini"
                    :data="scope.row.contentList"
                >
                  <el-table-column align="center" label="id">
                    <template slot-scope="contentScope">
                      <span>{{ contentScope.row.id }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="文件名">
                    <template slot-scope="contentScope">
                      <span>{{ contentScope.row.name }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="类型">
                    <template slot-scope="contentScope">
                      <el-tag v-if="contentScope.row.type === 0" type="success">文字</el-tag>
                      <el-tag v-if="contentScope.row.type === 1" type="success">音频</el-tag>
                      <el-tag v-if="contentScope.row.type === 2" type="success">图片</el-tag>
                      <el-tag v-if="contentScope.row.type === 3" type="success">视频</el-tag>
                      <el-tag v-if="contentScope.row.type === 6" type="success">文档</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="预览">
                    <template slot-scope="contentScope">
                      <el-button
                        v-if="contentScope.row.type !== 2"
                        type="text"
                        @click="viewFile(contentScope.row.type, contentScope.row.content)"
                        >预览</el-button
                      >
                      <el-image v-if="contentScope.row.type === 2" :src="contentScope.row.content" :preview-src-list="[contentScope.row.content]" style="width: 100px;"  />
                    </template>
                  </el-table-column>

                </el-table>
              </div>
            </template>

          </el-table-column>
          <el-table-column align="center" label="id">
            <template slot-scope="scope">
              <span>{{ scope.row.id }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="名称">
            <template slot-scope="scope">
              <span>{{ scope.row.productName }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="作者">
            <template slot-scope="scope">
              <el-link
                @click="
                  $router.push(
                    `/demo/user/userDetails?id=${scope.row.authorId}`
                  )
                "
                type="primary"
                >{{ scope.row.authorName }}</el-link
              >
            </template>
          </el-table-column>

          <el-table-column label="状态" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status === 0" type="danger"
                >未查看</el-tag
              >
              <el-tag v-if="scope.row.status === 1" type="warning"
                >已查看</el-tag
              >
              <el-tag v-if="scope.row.status === 2">已下载</el-tag>
              <el-tag v-if="scope.row.status === 3" type="success"
                >商家已确认</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column align="center" label="商家评价">
            <template slot-scope="scope">
              <el-rate v-model="scope.row.evaluate" disabled show-text>
              </el-rate>
            </template>
          </el-table-column>
          <el-table-column align="center" label="备注">
            <template slot-scope="scope">
              <span>{{ scope.row.remark }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="交付时间">
            <template slot-scope="scope">
              <span>{{ scope.row.createTime }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" min-width="200" label="操作" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="editInfo(scope.row)">修改信息</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          :current-page="queryForm.currentPage"
          :layout="layout"
          :page-size="queryForm.pageSize"
          :total="total"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </el-col>
    </el-row>
    <el-dialog
      title="修改信息"
      :visible.sync="showEdit"
      width="40%"
      :before-close="()=>{
        showEdit = false
      }"
    >
      <el-form ref="form" :model="editItem" label-width="80px">
        <el-form-item label="名称">
          <el-input v-model="editItem.productName" ></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="editItem.remark" ></el-input>
        </el-form-item>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showEdit = false">取 消</el-button>
        <el-button type="primary" @click="commitEditInfo">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="预览" :visible.sync="viewFileShow" append-to-body>
      <view-file :type="viewFileType" :content="viewFileContent"></view-file>
    </el-dialog>
  </div>
</template>
<script>
import {
  addContentForFile,
  commitProject, editSourceBaseInfo, getContentList,
  getSourcePage,
  selectSource,
  selectSourceForFile
} from '@/api/merchant/service/project'
import AddToCard from '@/pages/demo/punchTheClock/addToCard'
import { addToResource } from '@/api/demo/record'
import userInfo from '@/components/users/userInfo'
import {
  addFileResource,
  fileCategoryOptions,
  fileTagOption
} from '@/api/demo/file'
import selectFile from '@/components/file/selectFile.vue'
import contentPanel from '@/components/ContentPanel/index.vue'
import SpecView from '@/components/product/specView.vue'
import viewFile from '@/components/file/viewFile.vue'
/**
 * 富文本工具
 */

export default {
  name: 'serviceProjectSources',
  components: {
    viewFile,
    SpecView,
    selectFile,
    AddToCard,
    userInfo,
    contentPanel
  },
  data () {
    return {
      viewFileShow: false,
      viewFileType: 0,
      viewFileContent: '',
      expandRows: [],
      selectedFileIds: [],
      showEdit: false,
      editItem: {},
      id: this.$route.query.id,
      sourceList: [],
      layout: 'total, sizes, prev, pager, next, jumper',
      total: 0,
      listLoading: true,
      elementLoadingText: '正在加载...',
      queryForm: {
        currentPage: 1,
        pageSize: 10
      }
    }
  },
  created () {
  },
  methods: {
    editInfo (item) {
      this.editItem = item
      this.showEdit = true
    },
    commitEditInfo () {
      editSourceBaseInfo(this.editItem.id, this.editItem).then(res => {
        this.$message.success('修改成功')
        this.showEdit = false
        this.getSourceList()
      })
    },
    handleSizeChange (val) {
      this.queryForm.pageSize = val
      this.getSourceList()
    },
    handleCurrentChange (val) {
      this.queryForm.currentPage = val
      this.getSourceList()
    },
    addToResourceShow (logId) {
      this.currentToResourceId = logId
      this.showAddToResource = true
    },
    addToResource () {
      addToResource(this.currentToResourceId, this.addToResourceForm).then(
        (res) => {
          this.$message.success('添加成功')
          this.showAddToResource = false
          this.getInfo(this.id)
        }
      )
    },
    addDelivery (projectItemId) {
      this.currDeliveryItem = projectItemId
      this.showFileResource = true
    },
    expandContent (row) {
      if (this.expandRows.includes(row.id)) {
        // 删除该 id
        this.expandRows = this.expandRows.filter(item => {
          return item !== row.id
        })
        return
      }
      getContentList(row.id).then(res => {
      //   查询对应的 source
        let source = this.sourceList.filter(item => {
          if (item.id === row.id) {
            this.$set(item, 'contentList', res)
            return true
          }
        })
        this.expandRows.push(row.id)
        console.log('source', source)
      })
    },
    commitDelivery (fileIds) {
      this.selectedFileIds = fileIds
      selectSourceForFile(this.id, fileIds).then((res) => {
        this.$message.success('交付成功')
        this.showFileResource = false
        this.getSourceList()
      })
    },
    addContent (id, fileIds) {
      console.log('fileIds', fileIds)
      addContentForFile(id, fileIds).then((res) => {
        this.$message.success('添加成功')
        this.showFileResource = false
        this.expandRows = this.expandRows.filter(item => {
          return item !== id
        })
        this.expandContent({ id: id })
      })
    },
    // 交付
    delivery (id) {
      selectSource(id).then((res) => {
        this.$message.success('交付成功')
        this.getSourceList()
        this.getInfo(this.id)
      })
    },
    getSourceList () {
      this.queryForm.projectItemId = this.id
      getSourcePage(this.queryForm).then((res) => {
        this.sourceList = res.records
        this.total = parseInt(res.total)
      })
    },
    // 结束交付
    commitProject (id) {
      commitProject(id).then((res) => {
        this.$notify({
          title: '成功',
          message: '操作成功',
          type: 'success',
          duration: 2000
        })
        this.getInfo(this.id)
      })
    },
    viewFile (type, content) {
      console.log('type', type)
      this.viewFileType = type
      if (type === 6) {
        window.open(content)
      } else {
        this.viewFileContent = content
        this.viewFileShow = true
      }
    }
  },

  mounted () {
    this.getSourceList()
  }
}
</script>
<style scoped>
.body {
  padding: 40px;
}
#chart {
  width: 100%;
  min-height: 500px;
  margin-top: 20px;
  margin-left: 40px;
}
.draggable-element {
  position: fixed;
  border-radius: 20px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
  background-color: #fff;
  padding: 40px;
  left: 60px;
  top: 50%;
  cursor: move;
  z-index: 999;
}
.disDiv {
  /* display: flex; */
  border: 1px dotted;
  padding-bottom: 20px;
}
</style>
